import { SkanskaColorTokens } from "./colors";

// These are the color tokens that are used in VSAA. They are based on the Skanska color tokens, but can be overridden if needed
// SkanskaColorTokens is the source of truth for colors. VsaaColorTokens is the source of truth for how skanska colors are used in VSAA.
// This allows us to easily update the colors in VSAA without altering Skanska color tokens.
export const VsaaColorTokens = {
  color_hyperlink: SkanskaColorTokens.color_primary_blue,
  color_hyperlink_emphasis: "#0156b8",
  color_text_primary: "rgba(36,36,36,1)", // The fluent-ui default, not in SkanskaColorTokens
  color_text_disabled: SkanskaColorTokens.color_secondary_dark_gray,
  color_warning_icon: SkanskaColorTokens.color_action_orange,
  color_warning_background: SkanskaColorTokens.color_tertiary_orange_15,
  color_warning_border: SkanskaColorTokens.color_tertiary_orange,
  color_file_extension_badge_text: SkanskaColorTokens.color_secondary_dark_gray,
  color_file_extension_badge_background:
    SkanskaColorTokens.color_secondary_dim_white,
  color_file_extension_badge_border:
    SkanskaColorTokens.color_secondary_middle_gray,
  color_process_flow_section_divider:
    SkanskaColorTokens.color_secondary_middle_gray,
  color_new_document_indicator: SkanskaColorTokens.color_action_blue,
  color_grid_selection_border: SkanskaColorTokens.color_action_blue,
  color_destructive_button_background: SkanskaColorTokens.color_tertiary_red_30,
  color_destructive_button_background_hover:
    SkanskaColorTokens.color_tertiary_red,
  color_destructive_button_text: SkanskaColorTokens.color_secondary_white,
};
